import { EMPLOYEE_PERMISSION } from './permissions';

export const allEmployeesKey = (orgId: number) => `allEmployeesForOrg${orgId}`;
export const allEmployeesLabel = (user: User | AuthenticatedUser) =>
  user.employeesPermission === EMPLOYEE_PERMISSION.ALL ? 'All Employees' : 'All Direct Reports';
